<template>
  <Home />
</template>
<script>
import Home from '~src/modules/processing/views/Home.vue';

export default {
  components: {
    Home,
  },
};

</script>
